"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MessageAddSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var MessageAddSVG = function MessageAddSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M27,3H5A3,3,0,0,0,2,6V19a3,3,0,0,0,3,3H8v6a1,1,0,0,0,.08.38,1,1,0,0,0,.54.54.94.94,0,0,0,.76,0,1,1,0,0,0,.33-.21L16.41,22H27a3,3,0,0,0,3-3V6A3,3,0,0,0,27,3ZM20,13.5H17v3a1,1,0,0,1-2,0v-3H12a1,1,0,0,1,0-2h3v-3a1,1,0,0,1,2,0v3h3a1,1,0,0,1,0,2Z"
  }));
};
exports.MessageAddSVG = MessageAddSVG;
MessageAddSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MessageAddSVG);
exports.default = _default;